/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Reseller_Pricing_Enabled_OffInputs */

const id_reseller_pricing_enabled_off = /** @type {(inputs: Reseller_Pricing_Enabled_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} dinonaktifkan.`)
};

const en_reseller_pricing_enabled_off = /** @type {(inputs: Reseller_Pricing_Enabled_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} is off sale.`)
};

/**
* | output |
* | --- |
* | "{tld} is off sale." |
*
* @param {Reseller_Pricing_Enabled_OffInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_enabled_off = /** @type {((inputs: Reseller_Pricing_Enabled_OffInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Enabled_OffInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_enabled_off(inputs)
	return id_reseller_pricing_enabled_off(inputs)
});